<h2 mat-dialog-title mat-dialog-draggable-title>
  {{'enterprise_document_template_edit_pop.screen_name' | translate}}
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<form name="form" #f="ngForm" (ngSubmit)="f.form.valid && updateDocumentType()" appFocusFirstElement>
  <mat-dialog-content>
    <input type="hidden" class="form-control" name="id" id="id" [ngModel]="id" />
    <input type="hidden" class="form-control" name="parentId" id="parentId" [ngModel]="parentId" />
    <div class="row mt-3">
      <div class="col-12">
        <mat-form-field class="w-100">
          <input (focusout)="documentTypeEnterprise.name=documentTypeEnterprise.name.trim()" cdkFocusInitial
            #focusInput="matInput" matInput type="text"
            [placeholder]="'enterprise_document_template_edit_pop.lbl_document_name' | translate" name="name" id="name"
            [(ngModel)]="documentTypeEnterprise.name" #name="ngModel"
            [ngClass]="{ 'is-invalid': f.submitted && name.invalid }" maxlength="50" required />
          <button mat-button *ngIf="documentTypeEnterprise.name" type="button" matSuffix mat-icon-button aria-label="Clear"
            (click)="documentTypeEnterprise.name=''">
            <mat-icon>close</mat-icon>
          </button>
          <mat-error *ngIf="f.submitted && name.invalid && name?.errors.required">
            {{'validation.document_type' | translate}}
          </mat-error>
          <mat-error *ngIf="f.submitted && name?.errors?.duplicate">
            {{'validation.document_type_name_duplicate' | translate}}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-form-field class="w-100" *ngIf="parentId == null">
          <mat-label>{{'enterprise_document_template_edit_pop.lbl_service_type' | translate}}
          </mat-label>
          <mat-select #serviceTypesSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
            (focus)="commonService.openComboBox(checkFocus, serviceTypesSelect)" id="serviceTypeId" name="serviceTypeId"
            [(ngModel)]="documentTypeEnterprise.serviceType" #serviceTypeId="ngModel" required>
            <mat-option>
              <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                [placeholderLabel]="'search_form.search' | translate" [formControl]="serviceTypesFilterCtrl">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let serviceType of filteredServiceTypes | async" [value]="serviceType.id"
              (click)="this.commonService.closeDropdownList(this.serviceTypesSelect)">
              {{serviceType.name}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="f.submitted && serviceTypeId.invalid && serviceTypeId?.errors.required">
            {{'validation.service_type' | translate}}
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-100" *ngIf="parentId != null">
          <mat-label>{{'enterprise_document_template_edit_pop.lbl_parent_info' | translate}}
          </mat-label>
          <mat-select #parentSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
            (focus)="commonService.openComboBox(checkFocus, parentSelect)" id="idParent" name="parentId"
            [(ngModel)]="documentTypeEnterprise.parentId" #parentId="ngModel" required>
            <mat-option>
              <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                [placeholderLabel]="'search_form.search' | translate" [formControl]="parentIdsFilterCtrl">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let parentId of filteredParentIds | async" [value]="parentId.id"
              (click)="this.commonService.closeDropdownList(this.parentSelect)">
              {{parentId.name}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="f.submitted && parentId.invalid && parentId?.errors.required">
            {{'validation.parent_id' | translate}}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <mat-form-field class="mat-full-width">
          <textarea (focusout)="documentTypeEnterprise.description=documentTypeEnterprise.description.trim()"
            type="text" matInput [placeholder]="'headertable.description' | translate" rows="3" name="description"
            id="description" [(ngModel)]="documentTypeEnterprise.description" maxlength="200">
          </textarea>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>
  <mat-divider></mat-divider>
  <mat-dialog-actions align="center" class="mt-2">
    <button mat-stroked-button color="primary" class="mr-3" type="button" cdkFocusInitial (click)="cancel()">
      <mat-icon class="mr-0">cancel</mat-icon>{{'enterprise_document_template_edit_pop.buttons.cancel' | translate}}
    </button>
    <button mat-raised-button [disabled]="!isFormChanging" color="primary" type="submit">
      <mat-icon class="mr-0">save</mat-icon>{{'enterprise_document_template_edit_pop.buttons.save' | translate}}
    </button>
  </mat-dialog-actions>
</form>
